import { SocialWelfareLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "ad50bead-b7b1-4bae-bbb8-fb9e4bf51fa5",
    label: "N.F.B.S Application Form",
  },
  {
    fileStoreId: "18024226-2a59-4f3c-8a94-891f18042026",
    label: "IGNDPS Form",
  },
  {
    fileStoreId: "18024326-2a59-4f3c-8a94-891f18042026",
    label: "IGNOAPS Form",
  },
  {
    fileStoreId: "18024426-2a59-4f3c-8a94-891f18042026",
    label: "IGNWPS Form",
  },
  {
    fileStoreId: "18024526-2a59-4f3c-8a94-891f18042026",
    label: "III-U (NFSA/RKSY) Form",
  },
  {
    fileStoreId: "18024626-2a59-4f3c-8a94-891f18042026",
    label: "IV-U (NFSA/RKSY) Form",
  },
  {
    fileStoreId: "18024726-2a59-4f3c-8a94-891f18042026",
    label: "V-U (NFSA/RKSY) Form",
  },
  {
    fileStoreId: "",
    label: "VI-U (NFSA/RKSY) Form",
  },
];

const Social_welfare_Download_Forms = () => (
  <TableStructure
    title="Download Forms"
    heading={"Forms"}
    list={List}
    columnNo={1}
    leftMenuList={SocialWelfareLeftMenuList}
  />
);

export default Social_welfare_Download_Forms;
